export default function OpportunityPlan({ plan }) {
  if (!plan) return null;

  return (
    <section className="premium-card mt-10 p-6">
      <p className="text-sm font-black uppercase tracking-[0.18em] text-orange">Daily Collection Plan</p>
      <h2 className="mt-2 text-2xl font-black text-royal">{plan.title}</h2>
      <p className="mt-3 text-lg font-black text-maroon">{plan.earningPotential}</p>
      <p className="mt-2 max-w-3xl leading-7 text-muted">{plan.summary}</p>
      <div className="mt-6 grid gap-5 md:grid-cols-3">
        <ListBlock title="Facilities" items={plan.facilities} />
        <ListBlock title="Work Locations" items={plan.workLocations} />
        <ListBlock title="Eligibility" items={plan.eligibility} />
      </div>
      <div className="mt-5 rounded-sur bg-ivory p-4 text-sm font-bold text-maroon">
        Contact: {plan.contactNumbers.join(" / ")}
      </div>
    </section>
  );
}

function ListBlock({ title, items }) {
  return (
    <article className="rounded-sur border border-[var(--line)] p-4">
      <h3 className="mb-3 font-black text-ink">{title}</h3>
      <ul className="grid gap-2 text-sm leading-6 text-muted">
        {items.map((item) => (
          <li key={item}>✓ {item}</li>
        ))}
      </ul>
    </article>
  );
}
